module.exports = __webpack_public_path__ + "img/Vector rotated.833124dd.svg";